// User-facing copy: onboarding. Moved from the web app (pages/Welcome.tsx) so the web and the app say the same thing.
// Strings that take values are functions. Generated keys; rename freely, they're just names.
/** pages/Welcome.tsx */
export const welcome = {
    close: "Close",
    yourCard: "Your card",
    stepOf: (x, length) => `Step ${x} of ${length}`,
    aLittleAboutYou: "A little about you",
    bothOptionalTheyShow: "Both optional. They show on your card.",
    oneLineAboutYou: "One line about you",
    slowReaderFastTalker: "Slow reader, fast talker.",
    favouriteGenres: "Favourite genres ",
    upTo: (MAX_CLUB_GENRES) => `up to ${MAX_CLUB_GENRES}`,
    useHardcover: "Use Hardcover?",
    yourProgressUpdatesItself: "Your progress updates itself, and books you've read are filled in.",
    linkedAs: " Linked as ",
    pagematesOnlyAsksTo: "Pagemates only asks to read your library.",
    nothingWasLinkedYou: "Nothing was linked. You can link it later in Settings.",
    thatDidnTGo: "That didn't go through. You can try again later in Settings.",
    yourCardIsIssued: "Your card is issued",
    everyClubBookYou: "Every club book you finish gets a stamp.",
    back: "Back",
    skip: "Skip",
    notNow: "Not now",
    linkHardcover: "Link Hardcover",
    continue: "Continue",
    next: "Next",
    howClubmatesWillSee: "How clubmates will see you",
    yourNameAndPhoto: "Your name and photo show next to everything you post.",
    name: "Name",
    photo: "Photo",
    yourPicture: (provider) => `Your ${provider} picture`,
    yourUploadedPhoto: "Your uploaded photo",
    initials: "Initials",
    uploadAPhoto: "Upload a photo",
    howYouLlLook: "How you'll look in Talk",
    justNow: "just now",
    chapter3HadMe: "Chapter 3 had me. No spoilers past that.",
};
//# sourceMappingURL=onboarding.js.map